import {
  Button,
  RoundedModal,
  RoundedModalContent,
  RoundedModalFooter,
  RoundedModalHeader,
  RoundedModalTitle,
} from '@bridebook/aura';
import { InputV2 } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { toggleSnackbar } from '@bridebook/web/lib/bbcommon/actions';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { selectCurrentUserContactEmail } from '@bridebook/web/lib/users/selectors';
import { useDispatch } from '@bridebook/web/lib/utils';
import { Trans, useTranslation } from 'next-i18next';
import { useState } from 'react';
import { useSelector } from 'react-redux';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: () => Promise<void>;
}
export const SendTestEmailModal = ({ isOpen, onClose, onSend }: IProps) => {
  const { t } = useTranslation('inbox');
  const dispatch = useDispatch();

  const currentUserContactEmail = useSelector(selectCurrentUserContactEmail);
  const isEmailAvailable = !!currentUserContactEmail;
  const inputValue =
    currentUserContactEmail ?? t('guests.createMessageFlow.sendTestEmailForm.noEmailAdded');

  const [isLoading, setIsLoading] = useState(false);
  const onHandleSendTestEmail = async () => {
    setIsLoading(true);
    await onSend();
    setIsLoading(false);
    dispatch(
      toggleSnackbar(
        'success',
        t('guests.createMessageFlow.sendTestEmailForm.successMessage'),
        undefined,
        { icon: '🎉' },
      ),
    );
    onClose();
  };

  const handleOnOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  return (
    <RoundedModal isOpen={isOpen} onOpenChange={handleOnOpenChange} width="responsive-sm">
      <RoundedModalHeader>
        <RoundedModalTitle>
          {t('guests.createMessageFlow.sendTestEmailForm.title')}
        </RoundedModalTitle>
      </RoundedModalHeader>
      <RoundedModalContent>
        <div className="flex flex-col gap-4">
          <div className="text-center text-base leading-[150%] text-space">
            {t('guests.createMessageFlow.sendTestEmailForm.body2')}
          </div>
          <div className="flex flex-col gap-1">
            <InputV2
              label={t('guests.createMessageFlow.sendTestEmailForm.emailLabel')}
              disabled
              value={inputValue}
            />
            <div className="pl-4 text-xs font-semibold text-space-60">
              {!isEmailAvailable && (
                <Trans ns="inbox" i18nKey="guests.createMessageFlow.sendTestEmailForm.noEmail">
                  We can’t send you a test without an email address. Add yours in{' '}
                  <Link
                    href={UrlHelper.settings.accountDetails}
                    className="font-bold text-indigo-crush">
                    My Account
                  </Link>{' '}
                  to continue.
                </Trans>
              )}
            </div>
          </div>
        </div>
      </RoundedModalContent>
      <RoundedModalFooter>
        <Button loading={isLoading} onClick={onHandleSendTestEmail}>
          {t('guests.createMessageFlow.sendTestEmailForm.submitButton')}
        </Button>
      </RoundedModalFooter>
    </RoundedModal>
  );
};
